import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'ssf-logo',
    template: `<img [src]="logoURI" [alt]="logoAlt" class="ssf-logo" *ngIf="logoURI">`,
    styles: [`
        .ssf-logo {
            max-width: 100%;
            max-height: 100%;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent implements OnInit, OnChanges, OnDestroy {

    @Input() logo: Blob;
    @Input() public logoAlt: string;
    public logoURI: SafeUrl;
    private objectURL: string;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.createURI();
    }

    ngOnChanges(): void {
        this.createURI();
    }

    private createURI() {
        if (this.logo) {
            this.objectURL = window.URL.createObjectURL(this.logo);
            this.logoURI = this.sanitizer.bypassSecurityTrustUrl(this.objectURL);
        }
    }

    ngOnDestroy(): void {
        if (this.objectURL) {
            window.URL.revokeObjectURL(this.objectURL);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/logo/logo.component.ts